const fixedBtn = document.querySelector('.fixedBtn');
const scrollTopBtn = document.querySelector('.scrollTopBtn');

// Hide fixed "Contact us" button when near bottom of page (offset 200px)
if (fixedBtn) {

    window.addEventListener('scroll', () => {
        function hideBtn () {
            if ((window.innerHeight + document.documentElement.scrollTop) >= document.body.offsetHeight - 200) {
                fixedBtn.classList.add('hidden');
            } else {
                fixedBtn.classList.remove('hidden');
            }
        };

        hideBtn();
    })
}

// Scroll to top button
if (scrollTopBtn) {

    window.addEventListener('scroll', () => {
        function scrollToTop () {
            if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 20) {
                scrollTopBtn.classList.remove('hidden');
            } else {
                scrollTopBtn.classList.add('hidden');
            }
        }
        scrollToTop();
    })

    scrollTopBtn.addEventListener('click', () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    })
}
